import { useState, useEffect } from "react";
import "../styles/navbar.css";
import { BiMoon, BiSun } from "react-icons/bi";

let getCurrentTheme;
export default function NavBar() {
  //removing trancparency from navbar backround when it is scrolled
  const [headerVisible, setheaderVisible] = useState();
  function showNavbar() {
    // When the scroll is greater than 50 viewport height, add the headerVisible class to the navbar tag
    if (this.scrollY >= 50) {
      setheaderVisible("headerVisible");
    } else {
      setheaderVisible("");
    }
  }

  useEffect(() => {
    /*=============== LIGHT DARK THEME ===============*/
    const lightTheme = "light-theme";

    // Previously selected topic (if user selected)
    const selectedTheme = localStorage.getItem("selected-theme");

    // We obtain the current theme that the interface has by validating the light-theme class
    getCurrentTheme = () => document.body.classList.contains(lightTheme) ? "dark" : "light";

    // We validate if the user previously chose a topic
    if (selectedTheme) {
      // If the validation is fulfilled, we ask what the issue was to know if we activated or deactivated the light
      document.body.classList[selectedTheme === "dark" ? "add" : "remove"](lightTheme);
    }

    window.addEventListener("scroll", showNavbar);

  });
  function changetheme() {
    document.body.classList.toggle('light-theme');
    // We save the theme and the current icon that the user chose
    localStorage.setItem("selected-theme", getCurrentTheme());
  }
  //changing ThemeChanger icon on click
  const [moon, setmoon] = useState(true);
  function changeIcon() {
    if (moon === true) {
      setmoon(false);
    } else {
      setmoon(true);
    }
    changetheme();
  }
  //changing theme

  return (
    <nav className={`navbar ${headerVisible}`}>
      <p className="logoText">Vaibhav</p>
      {!document.body.classList.contains('light-theme') && (
        <BiMoon
          className="themeChanger"
          onClick={changeIcon}
          id="theme-button"
        />
      )}
      {document.body.classList.contains('light-theme') && (
        <BiSun
          className="themeChanger"
          onClick={changeIcon}
          id="theme-button"
        />
      )}
    </nav>
  );
}
